<template>
  <div>
    <ion-footer v-if="hasOrder">
      <ion-toolbar class="available-order">
        <ion-title>
          <span class="ion-stop-ellipsis">{{ statusText }}</span>
        </ion-title>
        <ion-buttons slot="end">
          <ion-button fill="outline" color="light" @click="handleDetails()">
            Details
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-footer>
  </div>
</template>

<script>
import {
  ORDER_OPEN,
  ORDER_PREPARING,
  ORDER_READY,
  ORDER_DELIVERING
} from "@/constants/order";
import { mapGetters } from "vuex";

export default {
  methods: {
    handleDetails() {
      this.$router.push({ name: "App: Order History" }).catch(e => e);
    }
  },

  computed: {
    ...mapGetters("order", ["openOrderStatus"]),

    hasOrder() {
      return this.openOrderStatus !== null;
    },

    statusText() {
      let status = this.openOrderStatus,
        text = "Order History";

      switch (status) {
        case ORDER_OPEN:
          text = "Order is processing...";
          break;
        case ORDER_PREPARING:
          text = "Order is being prepared.";
          break;
        case ORDER_DELIVERING:
          text = "Order is on it's way!";
          break;
        case ORDER_READY:
          text = "Ready for pick-up!";
          break;
      }

      return text;
    }
  }
};
</script>
